module.exports = __webpack_public_path__ + "static/media/EbitNielsen-LinhaTempo-h.0f7b7f5a.0f7b7f5a.png";